import { FilterField, labelId } from "kontrolEdge/helpers/advancedFilters";
import type { ResourceListItem } from "./types";

export function makeResourceCatalogFields(
  showCustomerColumn = false
): FilterField<ResourceListItem>[] {
  const fields: FilterField<ResourceListItem>[] = [
    {
      label: "Name",
      key: "name",
      accessor: (resource) => resource.label ?? "",
      type: "string",
      inFreeText: true,
    },
    {
      label: "Subscription Id",
      key: "subscriptionid",
      accessor: (resource) => resource.subtitle ?? "",
      type: "string",
      inFreeText: true,
    },
  ];

  if (showCustomerColumn) {
    fields.push({
      label: "Customer",
      key: "customer",
      accessor: (resource) => resource.customer?.name ?? "",
      type: "string",
      inFreeText: true,
    });
  }

  for (const field of fields) {
    field.key ??= labelId(field.label);
  }

  return fields;
}
